__turbopack_context__.v({
  "body": "gBidZW_body",
  "days": "gBidZW_days",
  "daysRose": "gBidZW_daysRose",
  "daysRoseOver": "gBidZW_daysRoseOver",
  "leadTimeRose": "gBidZW_leadTimeRose",
  "pill": "gBidZW_pill",
  "root": "gBidZW_root",
  "row": "gBidZW_row",
  "rowTrack": "gBidZW_rowTrack",
  "statusBody": "gBidZW_statusBody",
  "statusCell": "gBidZW_statusCell",
  "threshold": "gBidZW_threshold",
  "thresholdLabel": "gBidZW_thresholdLabel",
});
